import useGetMerchant from "@/pages/dashboard/profile/hooks/useGetMerchant";
import { useGetImage } from "@/utilities/helper/getImage";
import HomeHeader from "./HomeHeader";
import NotificationsBell from "./NotificationsBell";
import { todayTitle } from "./format";

// The manager's header: the salon's logo and name, today's date and notifications.
export default function SalonHeader() {
  const { data: merchant } = useGetMerchant();
  const { imageUrl } = useGetImage({ bucket: "merchant", image: merchant?.logo });
  return (
    <HomeHeader
      title={merchant?.businessInfo?.title}
      subtitle={todayTitle()}
      avatarUrl={imageUrl}
      to="/dashboard/profile"
      actions={<NotificationsBell />}
    />
  );
}
